import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { NzTableSortFn, NzTableSortOrder } from 'ng-zorro-antd/table';
import {fadeIn,wipeOutRight} from '../../app/shared/animation/animation.component';
interface DataItem {
  course_name: string;
  chapter_count: any;
  popularity: string;
  uploaded_date: string;
  expires_date: string;
  tag: any;
  checked: boolean;
}

interface ColumnItem {
  name: string;
  sortOrder: NzTableSortOrder | null;
  sortFn: NzTableSortFn<DataItem> | null;
  sortDirections: NzTableSortOrder[];
}

@Component({
  selector: 'course-listing',
  templateUrl: './course-listing.component.html',
  animations:[fadeIn,wipeOutRight]
})
export class CourseListingComponent implements OnInit, OnChanges {
  @Input() courseIds: string[] = [];
  @Input() courseData: any[] = [];
  @Output() checkedItemsCourse: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Input() selectedCourseIds: any;
  @Input() initiallyCheckedCourseIds: number[] = [];

  courseDataRaw: any[] = [];
  checkedItems: any[];
  anyChecked: any;
  allChecked: any;
  searchTerm:string;

  listOfColumns: ColumnItem[] = [
    {
      name: 'Courses',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.course_name.localeCompare(b.course_name),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Chapters',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.chapter_count- b.chapter_count,
      sortDirections: ['ascend', 'descend', null],
    },
    // {
    //   name: 'Popularity',
    //   sortOrder: null,
    //   sortFn: (a: DataItem, b: DataItem) =>
    //     a.course_name.localeCompare(b.popularity),
    //   sortDirections: ['ascend', 'descend', null],
    // },
    {
      name: 'Uploaded',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.uploaded_date.localeCompare(b.uploaded_date),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Expires',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) =>
        a.expires_date.localeCompare(b.expires_date),
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: 'Tags',
      sortOrder: null,
      sortFn: (a: DataItem, b: DataItem) => {
        const tagA = a.tag.map((tagObj) => tagObj.tag_name).join(', ');
        const tagB = b.tag.map((tagObj) => tagObj.tag_name).join(', ');
        return tagA.localeCompare(tagB);
      },
      sortDirections: ['ascend', 'descend', null],
    },
    {
      name: '',
      sortOrder: null,
      sortFn: null,
      sortDirections: [],
    },
  ];
  constructor() {}

  ngOnInit() {
    this.courseDataRaw = this.courseData
  }

  checkAll(value: boolean): void {
    this.courseData.forEach((data) => {
      data.checked = value;
    });
    this.updateCheckedItems();
  }

  onCheckboxChange(): void {
    this.updateCheckedItems();
  }

  private updateCheckedItems(): void {
    this.checkedItems = this.courseData
      .filter((element) => element.checked)
      .map((element) => element.course_id);

    this.anyChecked = this.courseData.some((e) => e.checked);
    this.allChecked = this.courseData.every((e) => e.checked);
    this.checkedItemsCourse.emit(this.checkedItems);
  }

  ngOnChanges(changes: SimpleChanges) {}

  onKeyUp(query: string): void {
    if (query) {
      let q: string;
      q = query.toLowerCase();
      const searchData = this.courseDataRaw.filter((d) => {
        var found = false;
        d.tag.forEach((tag) => {
          if (tag.tag_name.toLowerCase().includes(q)) {
            found = true;
          }
        });
        if (
          (d.course_name && d.course_name.toLowerCase().includes(q)) ||
          (d.chapter_count &&
            d.chapter_count.toString().toLowerCase().includes(q)) ||
          (d.uploaded_date && d.uploaded_date.toLowerCase().includes(q)) ||
          (d.expires_date && d.expires_date.toLowerCase().includes(q)) ||
          found
        ) {
          return d;
        }
      });
      this.courseData = searchData;
      this.courseData = [...this.courseData];
    } else {
      this.courseData = [...this.courseDataRaw];
    }
  }
  resetSearch(){
    if(this.searchTerm){
      this.searchTerm='';
      this.courseData= [...this.courseDataRaw];
    }
  }
  getMoreTagsContent(tags): string[] {
    return tags.slice(2).map((tag) => tag.tag_name);
  }

  moreTagsContent: string[];

  updateMoreTagsContent(tags): void {
    this.moreTagsContent = this.getMoreTagsContent(tags);
  }

  resetMoreTagsContent(): void {
    this.moreTagsContent = [];
  }
}
